import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import "./scss/common-tab.scss";

interface IProps {
  onChange: (code: string) => void;
  Cwidth?: number;
  active: string;
  list: Array<any>;
  active1?: string;
}
interface IState {}

const CommonTabList = (props: IProps, state: IState) => {
  const { onChange, Cwidth, active, list, active1 } = props;
  useEffect(() => {
    return () => {};
  }, []);
  const action = (code: string) => {
    onChange(code);
  };
  return (
    <section style={{ display: "flex", justifyContent: "center" }}>
      <section className="common-tab-warp">
        {list?.map((item: any) => (
          <p
            aria-hidden="true"
            key={item.name}
            style={{ width: `${Cwidth}px` }}
            className={
              item.name === active || item.name === active1
                ? "tab-item-active"
                : "tab-item"
            }
            onClick={() => action(item.name)}
          >
            {item.name}
          </p>
        ))}
      </section>
    </section>
  );
};

export default observer(CommonTabList);
